import React, {Component} from 'react';

import { InputGroup, InputGroupText, Input } from 'reactstrap';

import './styles.css';

class SearchAltVendor extends Component {
    constructor(props) {
        super(props)

        this.state= {
            item: '',
            major: '',
            minor: '',
            primaryVendor: '',
            altVendor: '',
            filterByItem: '',
            filterByAltVendor: ''
        }
    }

    handleItemChange = (e) => {
        let item = e.target.value;
        this.setState({item: item});
    }

    handleMajorChange = (e) => {
        let major = e.target.value;
        this.setState({major: major});
    }

    handleMinorChange = (e) => {
        let minor = e.target.value;
        this.setState({minor: minor});
    }

    handlePrimaryVendorChange = (e) => {
        let primaryVendor = e.target.value;
        this.setState({primaryVendor: primaryVendor});
    }

    handleAltVendorChange = (e) => {
        let altVendor = e.target.value;
        this.setState({altVendor: altVendor});
    }

    handleFilterItemChange = (e) => {
        let item = e.target.value;
        this.setState({filterByItem: item});
        this.props.filterItem(item);
    }

    handleFilterAltVendorChange = (e) => {
        let vendor = e.target.value;
        this.setState({filterByAltVendor: vendor});
        this.props.filterAltVendor(vendor);
    }

    keyPressedItem = (e, search) => {
        const key = e.key;   
        if(key === 'Enter') {
            switch(search) {
                case 'item':
                    if(this.state.altVendor.length > 0) {
                        this.props.triggerSearchItemAndAltVend(this.state.item, this.state.altVendor); 
                    } else {
                        this.props.triggerSearchItem(this.state.item); 
                    }
                    break;
                case 'major':
                    if(this.state.minor.length > 0) {
                        this.props.triggerSearchMajorAndMinor(this.state.major, this.state.minor); 
                    } else {
                        this.props.triggerSearchMajor(this.state.major); 
                    }
                      
                    break;
                case 'minor':
                    if(this.state.major.length > 0) {
                        this.props.triggerSearchMajorAndMinor(this.state.major,  this.state.minor); 
                    } else {
                        this.props.triggerSearchMinor(this.state.minor); 
                    }
                    break;
                case 'primaryVendor':
                    this.props.triggerSearchPrimaryVend(this.state.primaryVendor);  
                    break;
                case 'altVendor':
                    if(this.state.item.length > 0) {
                        this.props.triggerSearchItemAndAltVend(this.state.item, this.state.altVendor); 
                    } else {
                        this.props.triggerSearchAltVend(this.state.altVendor);  
                    }
                    break;
            }    
        }
    }
    

    render() {
        return (
            <div>
                 <div className="search-bar">
                    <InputGroup className="input-group-container">
                        <InputGroupText addonType="prepend">
                            <InputGroupText >Item</InputGroupText>
                        </InputGroupText>
                        <Input   onChange={this.handleItemChange}  value={this.state.item} onKeyPress={e => {this.keyPressedItem(e, 'item')}}/>
                    </InputGroup>
                    <InputGroup className="input-group-container">
                        <InputGroupText addonType="prepend">
                            <InputGroupText >Major</InputGroupText>
                        </InputGroupText>
                        <Input   onChange={this.handleMajorChange}  value={this.state.major} onKeyPress={e => {this.keyPressedItem(e, 'major')}}/>
                    </InputGroup>
                    <InputGroup className="input-group-container">
                        <InputGroupText addonType="prepend">
                            <InputGroupText >Minor</InputGroupText>
                        </InputGroupText>
                        <Input onChange={this.handleMinorChange}  value={this.state.minor} onKeyPress={e => {this.keyPressedItem(e, 'minor')}}/>
                    </InputGroup>
                    <InputGroup className="input-group-container">
                        <InputGroupText addonType="prepend">
                            <InputGroupText >Primary Vendor</InputGroupText>
                        </InputGroupText>
                        <Input   onChange={this.handlePrimaryVendorChange}  value={this.state.primaryVendor} onKeyPress={e => {this.keyPressedItem(e, 'primaryVendor')}} />
                    </InputGroup>
                    <InputGroup className="input-group-container">
                        <InputGroupText addonType="prepend">
                            <InputGroupText >Alternate Vendor</InputGroupText>
                        </InputGroupText>
                        <Input   onChange={this.handleAltVendorChange}  value={this.state.altVendor} onKeyPress={e => {this.keyPressedItem(e, 'altVendor')}} />
                    </InputGroup>
                </div>
                <div className="search-bar">
                    <InputGroup className="input-group-container">
                        <InputGroupText addonType="prepend">
                            <InputGroupText >Filter by Item</InputGroupText>
                        </InputGroupText>
                        <Input  onChange={this.handleFilterItemChange}  value={this.state.filterByItem}/>
                    </InputGroup>
                    <InputGroup className="input-group-container">
                        <InputGroupText addonType="prepend">
                            <InputGroupText >Filter by Alternate Vendor</InputGroupText>
                        </InputGroupText>
                        <Input  onChange={this.handleFilterAltVendorChange}  value={this.state.filterByAltVendor} />
                    </InputGroup>
                </div>
            </div>
        );
    }
    
}

export default SearchAltVendor;